import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ManufacturerService from "./manufacturerService";
import { AddManufacturerDTO, PaginationDTO } from "../../dtos/manufacturer";

// Define initial state
const initialState = {
  manufacturerDetails: [],
  manufacturerId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",

  isManufacturerLoading: false,
 
  isManufacturerLoadingError: false,
};



export const AddManufacturer = createAsyncThunk(
  "/api/pharmacy/manufacturer/add",
  async (manufacturer: AddManufacturerDTO, thunkAPI) => {
    try {
      return await ManufacturerService.AddManufacturer(manufacturer);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getManufacturerData = createAsyncThunk(
  "manufacturer/getManufacturerData", // Action type prefix
  async (dto:PaginationDTO | undefined, thunkAPI) => {
    try {
      const response = await ManufacturerService.getManufacturer(dto); // Call the function
      return response.data; // Assuming ManufacturerService.getManufacturer returns a Promise with data
    } catch (error :any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const manufacturerSlice = createSlice({
  name: "manufacturerSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeManufacturerId: (state, action) => {
      state.manufacturerId = action.payload.manufacturer;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getManufacturerData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getManufacturerData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.manufacturerDetails = action.payload.manufacturer;
        state.message = "";
      })
      .addCase(getManufacturerData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeManufacturerId } = manufacturerSlice.actions;
export default manufacturerSlice.reducer;
